<template>
  <div class="header—banner">
    <div class="nav">
      <div class="nav-content">
        <div class="left-nav">
          <img
            @click="toQiniuOfficial()"
            class="logo-1"
            src="https://www-static.qbox.me/sem/pili-live-1001/source/img/qiniu_logo-1.png"
            alt=""
          />
          <div class="text-box">
            <span @click="toQiniuOfficial()">首页</span>
            <span @click="toQiniuDetail()">关于我们</span>
          </div>
        </div>
        <div class="right-nav">
          <div @click="login()" class="login-button">
            <span>登录</span>
          </div>
          <div class="register-button">
            <span @click="toRegister()">立即注册</span>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-images">
      <div class="main-content">
        <div class="copyWriting">
          <img src="https://www-static.qbox.me/sem/pili-live-1001/source/img/banner-copywriting.png" alt="" />
          <div class="buttons-box">
            <div @click="toRegister()" class="banner-register">
              <div class="banner-register-button"><span>立即试用</span></div>
              <div class="register-tips"><span>0元试用七天</span></div>
            </div>
            <div @click="login()" class="banner-login">
              <span>已有账号登录</span>
            </div>
          </div>
        </div>
        <div class="illustration">
          <img src="https://www-static.qbox.me/sem/pili-live-1001/source/img/banner-illustration.png" alt="" />
        </div>
      </div>
    </div>

    <div class="labels">
      <div class="labels-content">
        <div class="label-box" v-for="(item, i) in labelsList" :key="i">
          <div class="icon-box">
            <img :src="item.icon" alt="" />
          </div>
          <div class="text-box">
            <div class="title">{{ item.title }}</div>
            <div class="content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img class="banner-images" src="" alt=""> -->
  </div>
</template>

<script>
export default {
  name: "headerBanner",
  props: {
    msg: String,
  },
  data() {
    return {
      labelsList: [
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/save-money.jpg",
          title: "省钱",
          content: "比同类产品便宜25%",
        },
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/easy-to-use.jpg",
          title: "易用",
          content: "零代码，极速搭建",
        },
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/stable.jpg",
          title: "稳定",
          content: "99.9%节点可用性",
        },
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/exclusive.jpg",
          title: "专属",
          content: "专属平台1v1服务",
        },
      ],
    };
  },
  methods: {
    toQiniuOfficial() {
      window.open("https://www.qiniu.com/");
    },
    toQiniuDetail() {
      window.open("https://www.qiniu.com/company");
    },
    login() {
      window.open("https://s.qiniu.com/uaANNn");
    },
    toRegister(){
      window.open("https://portal.qiniu.com/signup?invitation_type=700&invitation_key=L3IyafzJe97eD9iDke5CFmXK&redirect_url=https://s.qiniu.com/uaANNn")
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.header—banner {
  width: 100%;
  height: 720px;
  min-width: 1440px;
  position: relative;
  display: flex;
  background: #fff;
  .banner-images {
    width: 100%;
    height: 640px;
    background-position: center;
    background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/banner.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    .main-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 0 auto;
      height: 100%;
      .copyWriting {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .buttons-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          position: absolute;
          bottom: 0;
          left: 0;
          .banner-register {
            position: relative;
            font-family: PingFang SC;
            letter-spacing: 0em;
            .banner-register-button {
              position: absolute;
              bottom: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              color: #ff650e;
              background: #ffffff;
              cursor: pointer;
              &:hover {
                color: #ba3409;
                transition-duration: 0.5s;
              }
            }
            .register-tips {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              color: #ba3409;
            }
          }
          .banner-login {
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            border: 2px solid #fff;
            color: #fff;
            &:hover {
              background: #fff;
              color: #ff650e;
              transition-duration: 0.5s;
            }
          }
        }
      }
      .illustration {
        display: flex;
      }
    }

    @media screen and (min-width: 1441px) {
      .main-content {
        width: 1421px;
        .copyWriting {
          margin-top: 168px;
          width: 607px;
          height: 265px;
          .buttons-box {
            width: 364px;
            height: 70px;
            font-size: 20px;
            font-weight: 600;
            line-height: 52px;
            .banner-register {
              height: 100%;
              width: 168px;
              .banner-register-button {
                width: 168px;
                height: 52px;
                border-radius: 26px;
              }
              .register-tips {
                width: 89px;
                height: 25px;
                font-size: 14px;
                font-weight: 400;
                line-height: 15px;
                border-radius: 16px 16px 16px 0;
                background: linear-gradient(
                  166.21deg,
                  #ffe9e2 -3.43%,
                  #ffdd85 90.14%
                );
              }
            }
            .banner-login {
              margin-top: 18px;
              height: 52px;
              width: 168px;
              border-radius: 26px;
            }
          }
        }
        .illustration {
          margin-top: 133px;
          display: flex;
          width: 656px;
          height: 364px;
        }
      }
    }
    @media screen and (max-width: 1440px) {
      .main-content {
        width: 1190px;
        .copyWriting {
          margin-top: 190px;
          width: 559px;
          height: 244px;
          .buttons-box {
            width: 335px;
            height: 64px;
            font-size: 18px;
            font-weight: 600;
            line-height: 48px;
            .banner-register {
              height: 100%;
              width: 155px;
              .banner-register-button {
                width: 155px;
                height: 48px;
                border-radius: 24px;
              }
              .register-tips {
                width: 82px;
                height: 22px;
                font-size: 13px;
                font-weight: 400;
                line-height: 15px;
                border-radius: 14px 14px 14px 0px;
                background: linear-gradient(
                  166.21deg,
                  #ffe9e2 -3.43%,
                  #ffdd85 90.14%
                );
              }
            }
            .banner-login {
              margin-top: 16px;
              height: 44px;
              width: 155px;
              border-radius: 24px;
            }
          }
        }
        .illustration {
          margin-top: 155px;
          width: 603px;
          height: 336px;
        }
      }
    }
  }
  .nav {
    min-width: 1440px;
    // min-width: 1376px;
    width: 100%;
    height: 70px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    .nav-content {
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: PingFang TC;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0px;
      text-align: center;
      color: #fff;
      .left-nav {
        margin-left: 32px;
        line-height: 70px;
        width: 258px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .logo-1 {
          height: 22px;
          width: 78px;
          cursor: pointer;
          opacity: 1;
          &:hover {
            opacity: 0.7;
            transition-duration: 0.5s;
          }
        }

        .text-box {
          width: 132px;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          span {
            cursor: pointer;
            height: 68px;
            border-bottom: none;
            &:hover {
              transition-duration: 0.5s;
              opacity: .7;
            }
          }
        }
      }
      .right-nav {
        margin-right: 32px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 32px;
        width: 200px;
        div {
          display: flex;
          height: 32px;
          border-radius: 80px;
          line-height: 32px;
          text-align: center;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .login-button {
          border: 1px solid #fff;
          width: 76px;
          &:hover {
            background-color: #fff;
            color: #ff650e;
            transition-duration: 0.5s;
          }
        }
        .register-button {
          color: #ff650e;
          width: 104px;
          background-color: #fff;
          &:hover {
            color: #ba3409;
            transition: all .3s ease-in-out;
          }
        }
      }
    }
    // background: #fff;
    // padding: 0 32px;
  }
  .labels {
    width: 100%;
    height: 116px;
    min-width: 1440px;
    position: absolute;
    top: 572px;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .labels-content {
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .label-box {
        height: 100%;
        border-radius: 8px;
        background: #fff;
        display: flex;
        flex-direction: row;
        align-items: center;
        box-shadow: 0px 4px 32px 0px #0000000f;
        &:hover {
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
          transition: 0.3s;
          transform: translateY(-5px) !important;
          .icon-box {
            transform: scale(1.1);
            transition: 0.3s ease-in-out;
          }
          .text-box {
            .content {
              color: #333;
              transition: 0.5s;
            }
          }
        }
        .icon-box {
          width: 58px;
          height: 58px;
          display: flex;
          margin: 0 12px 0 24px;
        }
        .text-box {
          font-family: PingFang SC;
          letter-spacing: 0px;
          text-align: left;
          height: 68px;
          .title {
            font-size: 28px;
            height: 34px;
            line-height: 34px;
            color: #333;
          }
          .content {
            margin-top: 12px;
            font-size: 18px;
            font-weight: 400;
            height: 22px;
            line-height: 22px;
            color: #666;
          }
        }
      }
    }
    @media screen and (max-width: 1440px) {
      .labels-content {
        width: 1180px;
        .label-box {
          width: 280px;
          .text-box {
            .title {
              font-weight: 500;
            }
          }
        }
      }
    }
    @media screen and (min-width: 1441px) {
      .labels-content {
        width: 1420px;
        .label-box {
          width: 340px;
          .text-box {
            .title {
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
</style>
